export const getAutosaveKey = ({ editingNote, patientData, date }) => {
    if (editingNote) {
        return `autosave_note_${editingNote.id}`;
    }
    if (patientData && date) {
        return `autosave_note_new_${patientData.id}_${date}`;
    }
    return null;
};

export const saveToLocalStorage = ({ key, value }) => {
    if (key && value && value.trim() !== '') {
        localStorage.setItem(key, value);
    }
};

export const loadFromLocalStorage = ({ key }) => {
    if (!key) return '';
    return localStorage.getItem(key) || '';
};

export const clearFromLocalStorage = ({ key }) => {
    if (!key) return;
    localStorage.removeItem(key);
};
